/* Modern Sounds theme JS: mobile nav, reveal, AJAX cart drawer,
   predictive search modal, and the crate flipper. No dependencies. */
(function () {
  var R = (window.MS && window.MS.routes) || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  /* ---------- mobile nav ---------- */
  var toggle = $("#mobileToggle"), navM = $("#navMobile");
  if (toggle) toggle.addEventListener("click", function () { navM.classList.toggle("open"); });

  /* ---------- reveal ---------- */
  var revealEls = $$("[data-reveal]");
  if (!("IntersectionObserver" in window)) { revealEls.forEach(function (el) { el.classList.add("in"); }); }
  else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $("#cartDrawer"), scrim = $("#cartScrim"), itemsEl = $("#cartItems"),
      subEl = $("#cartSubtotal"), countEl = $("#cartCount");

  function openCart() { drawer.classList.add("open"); scrim.classList.add("open"); renderCart(); }
  function closeCart() { drawer.classList.remove("open"); scrim.classList.remove("open"); }

  $$("[data-cart-toggle]").forEach(function (b) { b.addEventListener("click", openCart); });
  if (scrim) scrim.addEventListener("click", closeCart);
  var cc = $("#cartClose"); if (cc) cc.addEventListener("click", closeCart);

  function renderCart() {
    fetch(R.cart + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (countEl) countEl.textContent = cart.item_count;
        if (subEl) subEl.textContent = money(cart.total_price);
        if (!itemsEl) return;
        if (!cart.items.length) { itemsEl.innerHTML = '<div class="cart-empty">Nothing in the crate yet.</div>'; return; }
        itemsEl.innerHTML = cart.items.map(function (l) {
          return '<div class="cart-line">' +
            '<div class="cover">' + (l.image ? '<img src="' + l.image + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : "") + "</div>" +
            '<div class="cart-line-meta">' +
              '<a class="t" href="' + l.url + '">' + esc(l.product_title) + "</a>" +
              '<div class="a">' + esc(l.vendor || "") + "</div>" +
              '<div class="p">' + money(l.final_line_price) + " &middot; qty " + l.quantity + "</div>" +
            "</div>" +
            '<button class="cart-remove" data-remove="' + l.key + '" aria-label="Remove">&times;</button>' +
          "</div>";
        }).join("");
        $$("[data-remove]", itemsEl).forEach(function (b) {
          b.addEventListener("click", function () {
            fetch(R.cart_change + ".js", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: b.dataset.remove, quantity: 0 })
            }).then(renderCart);
          });
        });
      });
  }

  function addVariant(id) {
    return fetch(R.cart_add + ".js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function () { openCart(); });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add-variant]");
    if (!b || b.disabled) return;
    e.preventDefault();
    b.textContent = "…";
    addVariant(b.dataset.addVariant).then(function () { b.textContent = "ADD"; });
  });
  if (countEl) renderCart();

  /* ---------- search modal ---------- */
  var sModal = $("#searchModal"), sScrim = $("#searchScrim"), sInput = $("#searchInput"), sResults = $("#searchResults");
  function openSearch() { sModal.classList.add("open"); sScrim.classList.add("open"); setTimeout(function () { sInput.focus(); }, 60); }
  function closeSearch() { sModal.classList.remove("open"); sScrim.classList.remove("open"); }
  $$("[data-search-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openSearch(); }); });
  if (sScrim) sScrim.addEventListener("click", closeSearch);
  var sc = $("#searchClose"); if (sc) sc.addEventListener("click", closeSearch);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeSearch(); closeCart(); } });

  var t;
  if (sInput) sInput.addEventListener("input", function () {
    clearTimeout(t);
    var q = sInput.value.trim();
    if (q.length < 2) { sResults.innerHTML = ""; return; }
    t = setTimeout(function () {
      fetch(R.predictive + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) {
            sResults.innerHTML = '<div class="search-empty"><p>No matches for &ldquo;' + esc(q) + '&rdquo;.</p><a class="more" href="' + R.search + "?q=" + encodeURIComponent(q) + '">See all results &rarr;</a></div>';
            return;
          }
          sResults.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : '<div class="cover-placeholder"></div>';
            return '<a class="search-result" href="' + p.url + '"><div class="cover">' + img + "</div>" +
              '<div class="search-result-meta"><div class="t">' + esc(p.title) + "</div>" +
              '<div class="a">' + esc(p.vendor || "") + " &middot; " + (p.price ? "$" + Number(p.price).toFixed(2) : "") + "</div></div></a>";
          }).join("");
        }).catch(function () { sResults.innerHTML = ""; });
    }, 180);
  });

  /* ---------- crate flipper ---------- */
  var stack = $("#digStack"), detail = $("#digDetail"), nextBtn = $("#digNextBtn"), filterEl = $("#digGenreFilter");
  if (stack) {
    var all = $$(".dig-card", stack);
    var active = new Set(), current = [], order = [], MAXD = 6;

    function build() {
      current = active.size === 0 ? all.slice() : all.filter(function (el) {
        var g = (el.dataset.genres || "").split(/\s+/);
        return g.some(function (h) { return active.has(h); });
      });
      all.forEach(function (el) { el.style.display = "none"; });
      if (!current.length) { detail.innerHTML = '<div class="dig-detail-inner"><p style="font-size:14px;">Nothing in that genre right now.</p></div>'; return; }
      current.forEach(function (el) { el.style.display = ""; });
      order = current.map(function (_, i) { return i; });
      layout();
    }
    function layout() {
      order.forEach(function (idx, pos) {
        var el = current[idx], depth = Math.min(pos, MAXD);
        el.style.zIndex = String(current.length - pos);
        el.style.transform = "translateY(" + depth * 3 + "px) rotateX(0deg)";
        el.style.opacity = "1";
        el.classList.toggle("front", pos === 0);
      });
      renderDetail();
    }
    function renderDetail() {
      var el = current[order[0]], d = el.dataset;
      detail.innerHTML = '<div class="dig-detail-inner">' +
        '<div style="font-weight:700;font-size:18px;">' + esc(d.title) + "</div>" +
        '<div style="font-size:14px;margin-top:2px;">' + esc(d.artist) + "</div>" +
        '<div class="price-row"><span style="font-weight:700;font-size:16px;">' + esc(d.price) + "</span>" +
        (d.available === "true" ? '<button class="add-btn" data-add-variant="' + d.variant + '">ADD</button>' : '<button class="add-btn" disabled style="opacity:.45;">SOLD</button>') +
        "</div></div>";
    }
    function flip() {
      var el = current[order[0]];
      el.classList.remove("front");
      el.style.zIndex = String(current.length + 1);
      el.style.transform = "translateY(40px) rotateX(-110deg)";
      el.style.opacity = "0";
      setTimeout(function () { order.push(order.shift()); layout(); }, 380);
    }
    if (nextBtn) nextBtn.addEventListener("click", flip);
    if (filterEl) $$("[data-genre]", filterEl).forEach(function (b) {
      b.addEventListener("click", function () {
        var h = b.dataset.genre;
        if (active.has(h)) active.delete(h); else active.add(h);
        b.classList.toggle("active");
        build();
      });
    });
    build();
  }
})();
